import { UrgencyBar, Hero } from "@/components/funnel/Hero";
import PaymentReturnBanner from "@/components/funnel/PaymentReturnBanner";
import {
  PainSection,
  AttorneyTrap,
  FiveMistakes,
  SavingsCalculator,
} from "@/components/funnel/PainSections";
import {
  HowItWorks,
  Founder,
  Personas,
} from "@/components/funnel/JourneySections";
import {
  OfferStack,
  Testimonials,
  Guarantee,
  FAQ,
  FinalCTA,
  Footer,
} from "@/components/funnel/OfferSections";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white antialiased grain overflow-x-hidden">
      <PaymentReturnBanner />
      <UrgencyBar />
      <main className="relative overflow-x-hidden">
        <Hero />
        <PainSection />
        <AttorneyTrap />
        <FiveMistakes />
        <SavingsCalculator />
        <HowItWorks />
        <Founder />
        <Personas />
        <OfferStack />
        <Testimonials />
        <Guarantee />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
